
export const constructsData = [
  {
    name: "Resilience",
    overview: {
      title: "Resilience Overview",
      qaList: [
        {
          question: "What does Resilience mean?",
          type: "p",
          content: "The capacity to recover quickly from difficulties and adapt to challenging situations."
        },
        {
          question: "How does Resilience look in real life?",
          type: "ul",
          content: [
            "Bouncing back after a job loss and actively seeking new opportunities",
            "Adapting to a new school or work environment after moving to a different city",
            "Maintaining a positive outlook and continuing to work towards goals despite setbacks"
          ]
        },
        {
          question: "What are typical outcomes of Resilience?",
          type: "ul",
          content: [
            "Higher academic achievement and GPA",
            "Better mental health and lower rates of depression",
            "Increased job satisfaction and career success",
            "Improved ability to cope with stress and adversity"
          ]
        },
        {
          question: "Citations",
          type: "ol",
          content: [
            "Masten, A. S. (2001). Ordinary magic: Resilience processes in development. American Psychologist, 56(3), 227-238.",
            "Luthar, S. S., Cicchetti, D., & Becker, B. (2000). The construct of resilience: A critical evaluation and guidelines for future work. Child Development, 71(3), 543-562.",
            "Werner, E. E. (1995). Resilience in development. Current Directions in Psychological Science, 4(3), 81-85."
          ]
        }
      ]
    },
    definition:
      "The capacity to recover quickly from difficulties and adapt to challenging situations.",
    image: "/placeholder.svg?height=200&width=400",
    contexts: {
      slide: {

      },
      stack: {

      },
      match: {

      }
    }
  },
  {
    name: "Persistence",
    definition:
      "The ability to continue working towards goals despite obstacles and setbacks.",
    overview: {
      title: "Persistence Overview",
      qaList: [
        {
          question: "What it means",
          type: "p",
          content: "The ability to continue working towards goals despite obstacles and setbacks."
        },
        {
          question: "What it looks like in real life",
          type: "ul",
          content: [
            "Continuing to practice a musical instrument daily, even when progress seems slow",
            "Submitting job applications consistently, despite facing multiple rejections",
            "Sticking to a fitness routine over months or years to achieve long-term health goals"
          ]
        },
        {
          question: "Typical outcomes",
          type: "ul",
          content: [
            "Higher academic achievement and graduation rates",
            "Increased likelihood of achieving long-term career goals",
            "Improved skill mastery in various domains",
            "Greater success in entrepreneurial ventures"
          ]
        },
        {
          question: "Citations",
          type: "ol",
          content: [
            "Duckworth, A. L., Peterson, C., Matthews, M. D., & Kelly, D. R. (2007). Grit: Perseverance and passion for long-term goals. Journal of Personality and Social Psychology, 92(6), 1087-1101.",
            "Eskreis-Winkler, L., Shulman, E. P., Beal, S. A., & Duckworth, A. L. (2014). The grit effect: Predicting retention in the military, the workplace, school and marriage. Frontiers in Psychology, 5, 36.",
            "Credé, M., Tynan, M. C., & Harms, P. D. (2017). Much ado about grit: A meta-analytic synthesis of the grit literature. Journal of Personality and Social Psychology, 113(3), 492-511."
          ]
        }
      ]
    },
    image: "/placeholder.svg?height=200&width=400",
    contexts: {
      slide: {

      },
      stack: {

      },
      match: {

      }
    }
  },
  {
    name: "Challenge-seeking",
    definition:
      "The tendency to pursue difficult tasks and embrace challenging situations.",
    overview: {
      title: "Challenge-seeking Overview",
      qaList: [
        {
          question: "What it means",
          type: "p",
          content: "The tendency to pursue difficult tasks and embrace challenging situations."
        },
        {
          question: "What it looks like in real life",
          type: "ul",
          content: [
            "Voluntarily taking on complex projects at work to expand skills",
            "Choosing advanced courses in school to push intellectual boundaries",
            "Participating in competitive sports or activities to test one's abilities"
          ]
        },
        {
          question: "Typical outcomes",
          type: "ul",
          content: [
            "Accelerated skill development and learning",
            "Higher levels of innovation and creativity in problem-solving",
            "Increased adaptability in rapidly changing environments",
            "Greater resilience in the face of setbacks"
          ]
        },
        {
          question: "Citations",
          type: "ol",
          content: [
            "Dweck, C. S. (2006). Mindset: The new psychology of success. Random House.",
            "Csikszentmihalyi, M. (1990). Flow: The psychology of optimal experience. Harper & Row.",
            "Bandura, A. (1997). Self-efficacy: The exercise of control. W.H. Freeman and Company."
          ]
        }
      ]
    },
    image: "/placeholder.svg?height=200&width=400",
    contexts: {
      slide: {
        construct_label: [
          { label: "Avoidant", behaviors_graph_key: "ChallengeSeeking_Avoidant", percentage: 0.9996650851318007 },
          { label: "Neutral", behaviors_graph_key: "ChallengeSeeking_Neutral", percentage: 0.1294413536076961 },
          { label: "Seeking", behaviors_graph_key: "ChallengeSeeking_Seeking", percentage: 4.0358461496168794e-07 },
          { label: "Disinterested", behaviors_graph_key: "ChallengeSeeking_Disinterested", percentage: 0.9999982511271076 }
        ],
        behaviors: {
          "ChallengeSeeking_Avoidant": [
            { label: "Time on Hard Levels", percentage: 75.80645161290323 },
            { label: "Extra Levels Attempted", percentage: 43.95161290322581 },
            { label: "Relative Hint Usage", percentage: 4.032258064516129 },
            { label: "Time on Challenge Levels", percentage: 6.048387096774194 },
            { label: "Time on Hard Challenge", percentage: 62.903225806451616 }
          ],
          "ChallengeSeeking_Neutral": [
            { label: "Challenge Attempts", percentage: 6.048387096774194 },
            { label: "Relative Hint Usage", percentage: 4.032258064516129 },
            { label: "Time on Challenge Levels", percentage: 6.048387096774194 },
            { label: "Early Level Hints Used", percentage: 39.91935483870967 }
          ],
          "ChallengeSeeking_Seeking": [
            { label: "Percent of Successful Attempts", percentage: 50.403225806451616 },
            { label: "Time on Hard Levels", percentage: 75.80645161290323 },
            { label: "Extra Levels Attempted", percentage: 43.95161290322581 },
            { label: "Challenge Attempts", percentage: 6.048387096774194 },
            { label: "Relative Hint Usage", percentage: 4.032258064516129 },
            { label: "Time on Challenge Levels", percentage: 6.048387096774194 },
            { label: "Time on Hard Challenge", percentage: 62.903225806451616 }
          ],
          "ChallengeSeeking_Disinterested": [],
        }
      },
      stack: {
        construct_label: [
          { label: "Avoidant", behaviors_graph_key: "ChallengeSeeking_Avoidant", percentage: 0.0054601139674423, },
          { label: "Neutral", behaviors_graph_key: "ChallengeSeeking_Neutral", percentage: 9.382081337310241e-08, },
          { label: "Seeking", behaviors_graph_key: "ChallengeSeeking_Seeking", percentage: 0.9957006175340156 }
        ],

        behaviors: {
          "ChallengeSeeking_Avoidant": [
            { label: "Accuracy Score", percentage: 12.903225806451612, },
            { label: "Average Goal Attained", percentage: 13.709677419354838, },
            { label: "Hard Levels Started", percentage: 37.5, },
            { label: "Attempts After Loss", percentage: 79.43548387096774, },
            { label: "Retries After Loss", percentage: 89.11290322580645, },
            { label: "Percent Hard Levels", percentage: 37.5, },
            { label: "Hard vs. Easy Level Ratio", percentage: 37.5, },
            { label: "Levels Replayed", percentage: 87.90322580645162 }
          ],
          "ChallengeSeeking_Neutral": [
            { label: "Details Exploration", percentage: 85.88709677419355, },
            { label: "Easy and Medium Level Starts", percentage: 87.90322580645162, },
            { label: "Hard Levels Started", percentage: 37.5, },
            { label: "Percent Hard Levels", percentage: 37.5, },
            { label: "Hard vs. Easy Level Ratio", percentage: 37.5 }
          ],
          "ChallengeSeeking_Seeking": [
            { label: "Accuracy Score", percentage: 12.903225806451612, },
            { label: "Average Goal Attained", percentage: 13.709677419354838, },
            { label: "Details Exploration", percentage: 85.88709677419355, },
            { label: "Easy and Medium Level Starts", percentage: 87.90322580645162, },
            { label: "Hard Levels Started", percentage: 37.5, },
            { label: "Attempts After Loss", percentage: 79.43548387096774, },
            { label: "Retries After Loss", percentage: 89.11290322580645, },
            { label: "Percent Hard Levels", percentage: 37.5, },
            { label: "Hard vs. Easy Level Ratio", percentage: 37.5, },
            { label: "Levels Replayed", percentage: 87.90322580645162 }
          ]
        }
      },
      match: {
        construct_label: [
          { label: "Avoidant", behaviors_graph_key: "ChallengeSeeking_Avoidant", percentage: 0.4093425943197044 },
          { label: "Neutral", behaviors_graph_key: "ChallengeSeeking_Neutral", percentage: 0.4724676168813873 },
          { label: "Seeking", behaviors_graph_key: "ChallengeSeeking_Seeking", percentage: 0.0005198592671727 }
        ],

        behaviors: {
          "ChallengeSeeking_Avoidant": [
            { label: "Average Moves Per Order", percentage: 76.61290322580645 },
            { label: "Part Placement Speed", percentage: 68.54838709677419 },
            { label: "Average Difficulty Multiplier", percentage: 58.06451612903226 },
            { label: "Powers Used", percentage: 78.62903225806451 },
            { label: "Total Gameplay Time", percentage: 42.74193548387097 },

          ],
          "ChallengeSeeking_Neutral": [
            { label: "Part Placement Speed", percentage: 68.54838709677419 },
            { label: "Average Drop Limit", percentage: 50.0 },
            { label: "Average Drop Speed", percentage: 31.048387096774192 },
            { label: "First Level Difficulty Increased", percentage: 77.41935483870968 },
            { label: "Total Time on Orders", percentage: 66.12903225806451 }
          ],
          "ChallengeSeeking_Seeking": [
            { label: "Average Drop Limit", percentage: 50.0 },
            { label: "Average Drop Speed", percentage: 31.048387096774192 },
            { label: "First Level Difficulty Increased", percentage: 77.41935483870968 },
            { label: "Total Time on Orders", percentage: 66.12903225806451 },
            { label: "Total Gameplay Time", percentage: 42.74193548387097 },
            { label: "Average Moves Per Order", percentage: 76.61290322580645 }
          ],
        }
      }
    }
  },
  {
    name: "Info-seeking",
    definition:
      "The drive to acquire new knowledge and understanding through active investigation.",
    image: "/placeholder.svg?height=200&width=400",
    overview: {
      title: "Info-seeking Overview",
      qaList: [
        {
          question: "What it means",
          type: "p",
          content: "The drive to acquire new knowledge and understanding through active investigation."
        },
        {
          question: "What it looks like in real life",
          type: "ul",
          content: [
            "Regularly reading scientific journals or news to stay informed about current events",
            "Asking probing questions during meetings or classes to deepen understanding",
            "Engaging in self-directed learning through online courses or workshops"
          ]
        },
        {
          question: "Typical outcomes",
          type: "ul",
          content: [
            "Enhanced problem - solving skills and critical thinking abilities",
            "Improved decision - making in personal and professional contexts",
            "Greater adaptability to technological changes and industry trends",
            "Increased likelihood of innovation and creative solutions"
          ]
        },
        {
          question: "Citations",
          type: "ol",
          content: [
            "Kashdan, T. B., Rose, P., & Fincham, F. D. (2004). Curiosity and exploration: Facilitating positive subjective experiences and personal growth opportunities. Journal of Personality Assessment, 82(3), 291-305.",
            "Litman, J. A. (2008). Interest and deprivation factors of epistemic curiosity. Personality and Individual Differences, 44(7), 1585-1595.",
            "Loewenstein, G. (1994). The psychology of curiosity: A review and reinterpretation. Psychological Bulletin, 116(1), 75-98."
          ]
        }
      ]
    },
    contexts: {
      slide: {
        construct_label: [
          { label: "Avoiding", behaviors_graph_key: "InformationSeeking_Avoiding", percentage: 0.9965756598052872 },
          { label: "Seeking", behaviors_graph_key: "InformationSeeking_Seeking", percentage: 0.001407414204442 }
        ],
        behaviors:
        {
          "InformationSeeking_Avoiding": [
            { label: "Checked Current Moves", percentage: 61.29032258064516 },
            { label: "Checked Moves Goal", percentage: 37.903225806451616 }
          ],
          "InformationSeeking_Seeking": [
            { label: "Checked Current Moves", percentage: 61.29032258064516 },
            { label: "Checked Moves Goal", percentage: 37.903225806451616 }
          ]
        }

      },
      stack: {

      },
      match: {

      }
    }
  },
  {
    name: "Problem Solving",
    definition: "The ability to find solutions to difficult or complex issues.",
    image: "/placeholder.svg?height=200&width=400",
    overview: {
      title: "Problem Solving Overview",
      qaList: [
        {
          question: "What it means",
          type: "p",
          content: "The ability to find solutions to difficult or complex issues."
        },
        {
          question: "What it looks like in real life",
          type: "ul",
          content: [
            "Developing a new strategy to increase company revenue",
            "Finding innovative ways to reduce waste in a manufacturing process",
            "Creating a compromise between conflicting parties in a dispute"
          ]
        },
        {
          question: "Typical outcomes",
          type: "ul",
          content: [
            "Higher job performance ratings and faster career advancement",
            "Increased ability to handle complex projects and tasks",
            "Better academic performance, especially in STEM fields",
            "Enhanced leadership capabilities and decision-making skills"
          ]
        },
        {
          question: "Citations",
          type: "ol",
          content: [
            "Newell, A., & Simon, H. A. (1972). Human problem solving. Prentice-Hall.",
            "Sternberg, R. J. (1986). Intelligence applied: Understanding and increasing your intellectual skills. Harcourt Brace Jovanovich.",
            "Mayer, R. E. (1992). Thinking, problem solving, cognition (2nd ed.). W.H. Freeman."
          ]
        }
      ]
    },
    contexts: {
      match: {
        construct_label: [
          { label: "BruteForce", behaviors_graph_key: "ProblemSolving_BruteForce", percentage: 0.9992383459512372 },
          { label: "Deliberate", behaviors_graph_key: "ProblemSolving_Deliberate", percentage: 0.0015358330416906 },
          { label: "Effective", behaviors_graph_key: "ProblemSolving_Effective", percentage: 2.962381863205842e-07 }
        ],
        behaviors: {
          "ProblemSolving_BruteForce": [
            { label: "Drop Efficiency", percentage: 88.70967741935483 },
            { label: "Successful Orders", percentage: 83.46774193548387 },
            { label: "Average Drop Reveals", percentage: 28.62903225806452 },
            { label: "Matches Made Per Part Dropped", percentage: 88.30645161290323 }
          ],
          "ProblemSolving_Deliberate": [
            { label: "Drop Efficiency", percentage: 88.70967741935483 },
            { label: "Total Moves", percentage: 70.56451612903226 },
            { label: "Successful Orders", percentage: 83.46774193548387 },
            { label: "Average Drop Reveals", percentage: 28.62903225806452 },
            { label: "Matches Made Per Part Dropped", percentage: 88.30645161290323 },
          ],
          "ProblemSolving_Effective": [
            { label: "Total Moves", percentage: 70.56451612903226 },
            { label: "Successful Orders", percentage: 83.46774193548387 },
            { label: "Average Drop Reveals", percentage: 28.62903225806452 },
            { label: "Checked Order Details", percentage: 67.74193548387096 }
          ],
        }
      },
      slide: {

      },
      stack: {

      }
    }
  },
  {
    name: "Goal Setting",
    definition:
      "The desire to accomplish tasks and meet standards of excellence.",
    image: "/placeholder.svg?height=200&width=400",
    overview: {
      title: "Achievement Orientation Overview",
      qaList: [
        {
          question: "What it means",
          type: "p",
          content: "The desire to accomplish tasks and meet standards of excellence."
        },
        {
          question: "What it looks like in real life",
          type: "ul",
          content: [
            "Setting and pursuing ambitious career goals",
            "Striving for top grades or academic honors",
            "Continuously improving performance in sports or other competitive activities"
          ]
        },
        {
          question: "Typical outcomes",
          type: "ul",
          content: [
            "Higher academic achievement and GPA",
            "Increased likelihood of attaining leadership positions",
            "Greater career success and job satisfaction",
            "Higher levels of personal and professional goal attainment"
          ]
        },
        {
          question: "Citations",
          type: "ol",
          content: [
            "McClelland, D. C. (1961). The achieving society. Van Nostrand.",
            "Elliot, A. J., & McGregor, H. A. (2001). A 2 × 2 achievement goal framework. Journal of Personality and Social Psychology, 80(3), 501-519.",
            "Dweck, C. S. (1986). Motivational processes affecting learning. American Psychologist, 41(10), 1040-1048."
          ]
        }
      ]
    },
    contexts: {
      slide: {
        construct_label: [
          { label: "Mastery", behaviors_graph_key: "AchievementOrientation_Mastery", percentage: 1.1736735988184418e-08 },
          { label: "Performance", behaviors_graph_key: "AchievementOrientation_Performance", percentage: 6.186435491529315e-16 }
        ],
        behaviors: {}

      },
      stack: {
        construct_label: [
          { label: "Competitive", behaviors_graph_key: "AchievementOrientation_Competitive", percentage: 0.0050983740186817 },
          { label: "Personal", behaviors_graph_key: "AchievementOrientation_Personal", percentage: 0.9982779504320558 }
        ],
        behaviors: {}
      },
      match: {
        construct_label: [
          { label: "Mastery", behaviors_graph_key: "AchievementOrientation_Mastery", percentage: 6.150831045430172e-05 },
          { label: "Performance", behaviors_graph_key: "AchievementOrientation_Performance", percentage: 0.466368051698119 }
        ],
        behaviors: {}
      },
    }
  },
];
 
export const reportingCategory = {
  "Resilience": "Resilience",
  "Persistence":"Persistence",
  "ChallengeSeeking": "Challenge-seeking",
  "InformationSeeking": "Info-seeking",
  "ProblemSolving": "Problem Solving",
  "GoalSetting":"Goal Setting",
  "DivergentThinking": "Divergent Thinking"
}